import { useLayoutEffect } from "react";
import { useOutletContext } from "react-router-dom";

export default function useFullScreen() {
  const { setFullScreen } =
    useOutletContext<{
      setFullScreen: (fullScreen: boolean) => void;
    }>() ?? {};

  useLayoutEffect(() => {
    if (setFullScreen) {
      setFullScreen(true);

      return () => {
        setFullScreen(false);
      };
    }
  }, [setFullScreen]);
  return;
}
